import { render } from "./DetailRoute.vue?vue&type=template&id=2d513750"
import script from "./DetailRoute.vue?vue&type=script&lang=js"
export * from "./DetailRoute.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__